import { createTableColumn } from '@fluentui/react-components'

import { RestSchemas } from '@/contexts/QueryProvider'
import { AppNameAndButton } from '../AppNameAndButton'
import { TeamsCellContent } from './TeamsCellContent'
import { RolesCellContent } from './RolesCellContent'
import { RowActionsMenu } from './RowActionsMenu'

type MessagesApplicationsApplication = RestSchemas['Messages.Applications.Application']

export const appTableColumns = [
  createTableColumn<MessagesApplicationsApplication>({
    columnId: 'appName',
    compare: (a, b) => {
      return a.appName.localeCompare(b.appName)
    },
    renderHeaderCell: () => {
      return 'Name'
    },
    renderCell: (item) => <AppNameAndButton item={item} />,
  }),
  createTableColumn<MessagesApplicationsApplication>({
    columnId: 'appKey',
    compare: (a, b) => {
      return a.appKey.localeCompare(b.appKey)
    },
    renderHeaderCell: () => {
      return 'Key'
    },
    renderCell: (item) => {
      return item.appKey
    },
  }),
  createTableColumn<MessagesApplicationsApplication>({
    columnId: 'status',
    compare: (a, b) => {
      return a.status.localeCompare(b.status)
    },
    renderHeaderCell: () => {
      return 'Status'
    },
    renderCell: (item) => {
      return item.status
    },
  }),
  createTableColumn<MessagesApplicationsApplication>({
    columnId: 'roleCount',
    compare: (a, b) => {
      return a.roleCount - b.roleCount
    },
    renderHeaderCell: () => {
      return 'Roles'
    },
    renderCell: (item) => <RolesCellContent item={item} />,
  }),
  createTableColumn<MessagesApplicationsApplication>({
    columnId: 'appTeamCount',
    compare: (a, b) => {
      return a.appTeamCount - b.appTeamCount
    },
    renderHeaderCell: () => {
      return 'Teams'
    },
    renderCell: (item) => <TeamsCellContent item={item} />,
  }),
  createTableColumn<MessagesApplicationsApplication>({
    columnId: 'actions',
    renderHeaderCell: () => {
      return 'Actions'
    },
    renderCell: (item) => <RowActionsMenu app={item} />,
  }),
]
